import React from "react";
import { BsTwitter, BsLinkedin, BsGithub } from "react-icons/bs";
import { FaFacebook } from "react-icons/fa";
import { RiInstagramFill } from "react-icons/ri";
import ReactTooltip from "react-tooltip";

const socialLinks = [
  {
    name: "Github",
    href: "https://github.com/Med-lemineHmd",
    icon: <BsGithub />,
  },
  {
    name: "Linkedin",
    href: "https://www.linkedin.com/in/mohamed-lemine-hamdinou-33b797151",
    icon: <BsLinkedin />,
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/mo_lemine_hmdn",
    icon: <RiInstagramFill />,
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/mohamedlemin.hamdinou",
    icon: <FaFacebook />,
  },
  {
    name: "Twitter",
    href: "https://twitter.com/lemine_hamdinou",
    icon: <BsTwitter />,
  },
];

const SocialMedia = () => {
  return (
    <>
      <div className="app__social dark:bg-darktheme dark:transition-all relative z-10">
        {socialLinks.map((socialLink) => (
          <div
            key={socialLink.name}
            data-tip={socialLink.name}
            className="bg-white border border-[#e4e4e4] dark:hover:bg-[#007991] dark:hover:border-[#007991] dark:bg-darkthemealt dark:border-[#2d3138] cursor-pointer"
          >
            <a href={socialLink.href} target="_blank" rel="noreferrer">
              {socialLink.icon}
            </a>
          </div>
        ))}
      </div>
      <ReactTooltip effect="solid" type="dark" place="right"></ReactTooltip>
    </>
  );
};

export default SocialMedia;
